import React from "react";
import Tab, { TabGroup } from "@amzn/meridian/tab";
import { useAppSelector } from "src/store/store";

interface tabGroupProps {
  currentTab: string;
  setCurrentTab: (newTab: string) => void;
}
const tabGroup = ({ currentTab, setCurrentTab }: tabGroupProps) => {
  const {
    activePlacementsTableData,
    expiredPlacementsTableData,
    pendingPlacementsTableData,
    closedPlacementsTableData
  } = useAppSelector((state) => state.placementOverviewPage);

  return (
    <TabGroup value={currentTab} onChange={setCurrentTab}>
      <Tab value="pendingPlacements">
        Pending Placements ({pendingPlacementsTableData.length})
      </Tab>
      <Tab value="expiredPlacements">
        Expired Placements ({expiredPlacementsTableData.length})
      </Tab>
      <Tab value="activePlacements">
        Active Placements ({activePlacementsTableData.length})
      </Tab>
      <Tab value="closedPlacements">
        Closed Placements ({closedPlacementsTableData.length})
      </Tab>
    </TabGroup>
  );
};

export default tabGroup;
